import React from 'react';
import styles from './SoftwareAgencyCardsSection.module.css';
import { isSmallScreen } from '../../../utils/screen';
import { FaTerminal } from 'react-icons/fa';

interface SoftwareAgencyCardsSectionProps {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    cards: Array<{
        title: React.ReactNode;
        description: React.ReactNode;
    }>;
}

const SoftwareAgencyCardsSection: React.FC<SoftwareAgencyCardsSectionProps> = ({ title, subtitle, cards }) => {
    return (
        <section className={styles.section}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <FaTerminal size={isSmallScreen() ? 44 : 54} className={styles.terminalIcon} />
                    <div className={styles.headerContent}>
                        <h2 className={styles.title}>{title}</h2>
                        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                    </div>
                </div>
                <div className={styles.cardsContainer}>
                    {cards.map((card, index) => (
                        <div key={index} className={styles.card}>
                            <h3 className={styles.cardTitle}>{card.title}</h3>
                            <p className={styles.cardDescription}>{card.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SoftwareAgencyCardsSection; 